var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23.75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Camada 2",
    id: "Camada_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Camada 1",
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,12.24H22.39a7,7,0,0,0-4.12-4.51,4.74,4.74,0,0,0,1-2.94,4.79,4.79,0,0,0-9.58,0,4.74,4.74,0,0,0,1.13,3.06c-.58.16-1.44.43-2.53.83A16.54,16.54,0,0,0,5.25,5.51a.5.5,0,0,0-.81.4V11A18.66,18.66,0,0,0,2,13.36H.5a.5.5,0,0,0-.5.5v3.73a.5.5,0,0,0,.3.46l6.95,3v1.22a1.5,1.5,0,0,0,1.49,1.49h1.53a1.5,1.5,0,0,0,1.49-1.49V21.2h3.85v1.05a1.5,1.5,0,0,0,1.49,1.49h1.53a1.5,1.5,0,0,0,1.49-1.49V19.58a6.79,6.79,0,0,0,2.47-6.35h.89a.5.5,0,0,0,0-1ZM14.52,1a3.79,3.79,0,1,1-3.79,3.79A3.79,3.79,0,0,1,14.52,1Zm4.82,18,0,0-.07.08,0,.07a.5.5,0,0,0,0,.09.52.52,0,0,0,0,.1s0,0,0,0v2.9a.5.5,0,0,1-.49.49H17.12a.5.5,0,0,1-.49-.49v-1.6a61.24,61.24,0,0,1,0-.18l-.05-.08-.06-.08-.07,0-.09-.05-.09,0-.09,0H11.27a.5.5,0,0,0-.5.5v1.55a.5.5,0,0,1-.49.49H8.75a.5.5,0,0,1-.49-.49V20.71h0s0,0,0,0a.49.49,0,0,0,0-.16.47.47,0,0,0-.05-.08A.35.35,0,0,0,8,20.26l0,0h0L1,17.26v-2.9H2.24a.5.5,0,0,0,.4-.19,17.11,17.11,0,0,1,2.62-2.56l0,0,.07-.08,0-.07a.47.47,0,0,0,0-.09.48.48,0,0,0,0-.1V7A11.48,11.48,0,0,1,7.7,9.52a.49.49,0,0,0,.15.16l0,0a.49.49,0,0,0,.22.07H8.3c1.74-.64,3-1,3.41-1.09A4.7,4.7,0,0,0,17.5,8.5,6,6,0,0,1,19.34,19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.38,
    cy: 14.02,
    r: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.88,10.11H11.15a.5.5,0,0,0,0,1h6.73a.5.5,0,0,0,0-1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.0b46fdde78ae559bb7ddac45850351f6.svg";
export { ForwardRef as ReactComponent };